<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md text-center"
  >
    <div class="trezo-card-content py-[25px]">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px]">
        <div class="md:px-[25px] relative">
          <span
            class="inline-block text-gray-400 rounded-md py-[6.5px] px-[17.3px] border border-gray-100 dark:border-[#172036]"
          >
            Basic
          </span>
          <div
            class="leading-none text-4xl text-black dark:text-white my-[15px] md:my-[17px] font-medium -tracking-[1px]"
          >
            $29
            <span
              class="text-md text-gray-500 dark:text-gray-400 font-normal tracking-normal"
            >
              / per month
            </span>
          </div>
          <p class="font-medium">For individual user</p>
          <button
            type="button"
            class="block w-full rounded-md font-medium transition-all md:text-md mt-[20px] md:mt-[20px] py-[12px] px-[20px] text-white bg-primary-500 hover:bg-primary-400"
          >
            <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
              <i
                class="material-symbols-outlined !text-md absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                arrow_forward_ios
              </i>
              Buy Now
            </span>
          </button>
          <ul class="mt-[20px] md:mt-[28px] ltr:text-left rtl:text-right">
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Basic Dashboard
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Task Management
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              File Storage (5GB)
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Basic Reporting
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Email Integration
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Basic Support
            </li>
          </ul>
          <div
            class="absolute top-0 bottom-0 ltr:-right-[10px] rtl:-left-[10px] border-r border-gray-100 dark:border-[#172036] border-dashed hidden sm:block"
          ></div>
        </div>
        <div class="md:px-[25px] relative">
          <span
            class="inline-block text-gray-400 rounded-md py-[6.5px] px-[17.3px] border border-gray-100 dark:border-[#172036]"
          >
            Standard
          </span>
          <div
            class="leading-none text-4xl text-black dark:text-white my-[15px] md:my-[17px] font-medium -tracking-[1px]"
          >
            $49
            <span
              class="text-md text-gray-500 dark:text-gray-400 font-normal tracking-normal"
            >
              / per month
            </span>
          </div>
          <p class="font-medium">For team of 10 users</p>
          <button
            type="button"
            class="block w-full rounded-md font-medium transition-all md:text-md mt-[20px] md:mt-[20px] py-[12px] px-[20px] text-white bg-primary-500 hover:bg-primary-400"
          >
            <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
              <i
                class="material-symbols-outlined !text-md absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                arrow_forward_ios
              </i>
              Buy Now
            </span>
          </button>
          <ul class="mt-[20px] md:mt-[28px] ltr:text-left rtl:text-right">
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Advanced Dashboard
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Task Management
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              File Storage (10GB)
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Advanced Reporting
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Email Integration
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Priority Support
            </li>
          </ul>
          <div class="absolute -top-[15px] ltr:right-[10px] rtl:left-[10px]">
            <img
              src="@/assets/images/icons/star-popular.svg"
              alt="popular-image"
            />
          </div>
          <div
            class="absolute top-0 bottom-0 ltr:-right-[10px] rtl:-left-[10px] border-r border-gray-100 dark:border-[#172036] border-dashed hidden md:block"
          ></div>
        </div>
        <div class="md:px-[25px] relative">
          <span
            class="inline-block text-gray-400 rounded-md py-[6.5px] px-[17.3px] border border-gray-100 dark:border-[#172036]"
          >
            Premium
          </span>
          <div
            class="leading-none text-4xl text-black dark:text-white my-[15px] md:my-[17px] font-medium -tracking-[1px]"
          >
            $79
            <span
              class="text-md text-gray-500 dark:text-gray-400 font-normal tracking-normal"
            >
              / per month
            </span>
          </div>
          <p class="font-medium">For team of 15 users</p>
          <button
            type="button"
            class="block w-full rounded-md font-medium transition-all md:text-md mt-[20px] md:mt-[20px] py-[12px] px-[20px] text-white bg-primary-500 hover:bg-primary-400"
          >
            <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
              <i
                class="material-symbols-outlined !text-md absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                arrow_forward_ios
              </i>
              Buy Now
            </span>
          </button>
          <ul class="mt-[20px] md:mt-[28px] ltr:text-left rtl:text-right">
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Customizable Dashboard
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Task Management
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              File Storage (Unlimited)
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Custom Reporting
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Email Integration
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              24/7 Premium Support
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingStyleThree",
};
</script>
